import { Modal } from 'bootstrap'

export const isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

export const isLocalHost = window.location.hostname === 'localhost';

export function isLog(message?: any, ...optionalParams: any[]) {
    if (isLocalHost) {
        console.log(message, ...optionalParams);
    }
}

// Transition from one element to another.
export function setText(className: string, text: string) {
    var elements = document.getElementsByClassName(className);
    Array.from(elements).forEach((element) => {
        if (element instanceof HTMLImageElement) {
            element.src = text;
        } else if (element instanceof HTMLElement) {
            element.innerHTML = text;
        }
    });
}

export function hideModal(id: string) {
    var element = document.getElementById(id);
    if (element) {
        var modal = new Modal(element);
        modal.hide();
    } else {
        console.error(`Modal with id ${id} not found`);
    }
}

export function show(id: string) {
    document.getElementById(id)?.classList.remove('d-none');
}

export function hide(id: string) {
    document.getElementById(id)?.classList.add('d-none');
}

export function transition(from: string, to: string) {
    hide(from);
    show(to);
}

export function on(id:string, callback: () => void) {
    if (document.getElementById(id)) {  
        (document.getElementById(id) as HTMLButtonElement).onclick = callback;
    } else {
        console.error(`Element with id ${id} not found`);
    }
}
export function showError(error: string) {
    var element = document.getElementById('errorModal');
    if (element) {
        var errorModal = new Modal(element);
        setText('errorMessage', error);
        errorModal.show();
    }
}
